import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BaseEvent } from './baseEvent';
import { AuthService } from '../../../../../../shared/services/auth.service';
import { ViewProductInfoHandlerService } from '../../../../services/view-product-info-handler.service';
import { GetBusinessProfileService } from '../../../../../../shared/services/get-business-profile.service';
import { CurrencyExchangeService } from '../../../../../../shared/services/currency-exchange.service';
import { GetCalculatesParamsService } from '../../../../services/get-calculates-params.service';
import { MapDialogComponent } from '../../../../../../shared/components/map-dialog/map-dialog.component';
import { CongratulationComponent } from '../../../../../../shared/components/congratulation/congratulation.component';
import { ProductExtraInfos } from '../../../../buyer';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { eventProdObject, EventTerms, EventTicket } from './event.interface';
import { ProductCreationHelperService } from 'src/app/dashboard/seller/payment-pages/services/product-creation-helper.service';
import { ProductTypes } from 'src/app/shared/product/productTypes';

@Component({
  selector: 'app-event',
  templateUrl: './event.component.html',
  styleUrls: ['./event.component.scss']
})
export class EventComponent extends BaseEvent implements OnInit,AfterViewInit {
  parsedTickets: EventTicket[] = [];
  mapCurrency = false;
  startDay: any;
  endDay: any;
  eventLocation;
  eventAddress;
  url = window.location.href;
  categoryName: any;
  btns = ["facebook"];
  facebookLink: any;
  eventImage: any;
  description: string = '';
  allTicketsSold: boolean = true;
  isProcessingRequest: boolean = false;
  productId: any;
  expired: any;
  deliveryTerms:string;
  returnTerms:string;
  @Input() productObject: eventProdObject;
  businessObject: any;
  deliveryTermsPopUpTitle:string;
  returnTermsPopUpTilte:string;
  OkPopUpMessage:string;
  eventTermsObject:EventTerms;
  constructor(
    md: MatDialog,
    vpihs: ViewProductInfoHandlerService,
    auth: AuthService,
    getBusinessProfileService: GetBusinessProfileService,
    private Dialog: MatDialog,
    public exchangeService: CurrencyExchangeService,
    public getCalculatesParamsService: GetCalculatesParamsService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private translate:TranslateService,
    private productCreationHelperService: ProductCreationHelperService
  ) {
    super(md, vpihs, auth, getBusinessProfileService, exchangeService, getCalculatesParamsService);
  }
  ngAfterViewInit() {
    this.eventTermsObject={
      ...this.eventTermsObject,
      deliveryTermsPopUpTitle:this.translate.instant('Buyer.DeliveryTerms'),
      returnTermsPopUpTilte:this.translate.instant('Buyer.ReturnTerms'),
      OkPopUpMessage:this.translate.instant('Buyer.OK'),
    }
    this.eventTermsObject.deliveryTermsPopUpTitle=this.translate.instant('Buyer.DeliveryTerms');
    this.eventTermsObject.returnTermsPopUpTilte=this.translate.instant('Buyer.ReturnTerms');
    this.eventTermsObject.OkPopUpMessage=this.translate.instant('Buyer.OK');
    this.translate.onLangChange.subscribe(() => {
      this.eventTermsObject={
        ...this.eventTermsObject,
        deliveryTermsPopUpTitle:this.translate.instant('Buyer.DeliveryTerms'),
        returnTermsPopUpTilte:this.translate.instant('Buyer.ReturnTerms'),
        OkPopUpMessage:this.translate.instant('Buyer.OK'),
      }
    });

  }
  async ngOnInit() {
    this.businessObject = this.productObject.Business;
    this.description = this.getNewProductValueByFieldName('description', 'ProductExtraInfos');
    this.eventImage = this.getNewProductValueByFieldName("image", "EventProductExtraInfo");
    this.facebookLink = this.getNewProductValueByFieldName("facebookEventLink", "EventProductExtraInfo");
    let category = this.getNewProductValueByFieldName("ProductTypeCategory", "EventProductExtraInfo");
    this.eventTermsObject = { ...this.eventTermsObject,
      deliveryTerms: this.getNewProductValueByFieldName("deliveryTerms", "EventProductExtraInfo"),
      returnTerms: this.getNewProductValueByFieldName("returnTerms", "EventProductExtraInfo")
     };
    this.categoryName = category.name;
    this.vpihs.currency = this.getNewProductValueByFieldName('currency','ProductExtraInfos');
    await this.initCurrencies();
    const eventDurationValue = this.getNewProductValueByFieldName(
      'eventDuration',
      'EventProductExtraInfo',
    );
    let eventDuration = "";
    if (eventDurationValue != "") {
      eventDuration = JSON.parse(
        this.getNewProductValueByFieldName("eventDuration", "EventProductExtraInfo")
      );
    }
    this.Tickets = this.productObject.EventTickets;
    const startDate = eventDuration[0] ? new Date(eventDuration[0]) : null;
    const endDate = eventDuration[1] ? new Date(eventDuration[1]): null;
    this.startDay = startDate
    this.endDay = endDate
    this.eventLocation=this.getNewProductValueByFieldName("eventLocation",
      'EventProductExtraInfo')
      this.eventAddress=this.getNewProductValueByFieldName("eventAddress",
        'EventProductExtraInfo')
    this.parsedTickets = this.Tickets.map((ticket: EventTicket) => {
      let activeQuantity = ticket.quantity - ticket.pendingQuantity - ticket.paidQuantity

      if (activeQuantity) this.allTicketsSold = false;
      return {
        id: ticket.id,
        eventDuration: eventDuration,
        name: ticket.name,
        description: ticket.description,
        quantity: activeQuantity,
        maxQuantityPerSale: ticket.maxQuantityPerSale ? Math.min(ticket.maxQuantityPerSale, activeQuantity) : activeQuantity,
        price: ticket.price,
        quantityPerTicket: 1,
        expired: new Date() > new Date(ticket.expiry),
      };
    });

    this.productCreationHelperService.checkParamsForOpriningCopyDialog(window.location.search, {
      serilizedUrl: this.url?.split("?")[0],
      product: {
        name: this.productObject.productName,
        type: ProductTypes.Event
      }
    })
  }

  async openShareButtonsDialog() {
    this.Dialog.open(CongratulationComponent, {
      panelClass: "responsive-dialog",
      data: {
        url: this.url,
        name: this.productObject.productName,
        type: "Event",
        showCongratulation: false,
        showButton: false
      }
    });
  }

  openMap() {
    this.Dialog.open(MapDialogComponent, {
      height: "400px",
      width: "500px",
      data: {
        coordinates: this.getNewProductValueByFieldName("eventLocation", "EventProductExtraInfo")
      }
    });
  }

  animationEvent(type: string) {
    let infoBar = document.getElementById('info-bar');
    let productCoverTag = document.getElementById('product-cover-tag');
    if (infoBar && productCoverTag) {
      if (type == 'in') {
        productCoverTag.style.opacity = '.2';
        infoBar.style.marginTop = '2rem';
      } else if (type == 'out') {
        productCoverTag.style.opacity = '1';
        infoBar.style.marginTop = '-6rem';
      };
    }
  }

  getNewProductValueByFieldName(fieldName: any, productFieldValues = 'ProductExtraInfos') {
    if (productFieldValues == 'ProductExtraInfos') {
      const allFields: Array<ProductExtraInfos> = this.productObject.ProductExtraInfos;
      for (const field of allFields) {
        if (field.key === fieldName) {
          return field.value;
        }
      }
    }
    else {
      const allFields = this.productObject[productFieldValues];
      if (allFields) {
        for (const key of Object.keys(allFields)) {
          if (key === fieldName) {
            if (fieldName === 'price') {
              // handle converstion when currency is not EGP
              if (this.vpihs.currency !== 'EGP') {
                const result = this.getExchangedValue(+allFields[key], this.vpihs.currency);
                return result;
              }
            }
            return allFields[key];
          }
        }
      }
    }
    return undefined;
  }

  proceedToPayment() {
    this.vpihs.setViewInfoObject({
      product: this.productObject,
      extras: this.extrasObject
    });
    this.vpihs.BusinessId = this.productObject.BusinessId;
    this.getCalculatesParamsService.setQuantity(this.quantity);
    this.getCalculatesParamsService.calculateInfos();
    this.vpihs.quantity = this.quantity;
    this.router.navigate(["buyerinfo"], { relativeTo: this.activatedRoute });
    console.log(this.vpihs);
  }

  formatDescription(description: string): string {
    const value = description?.trim();
    if (!value) {
      // Use translated fallback
      return this.translate.instant('Buyer.NoDescription');
    }

    // Replace newlines with <br>
    return value.replace(/\n/g, '<br>');
  }
}
